import _ from 'lodash';
import * as ProjectApi from './ProjectApi';
import ProjectConstants from './ProjectConstants';

const receivedProject = (project) => ({
    type: ProjectConstants.PROJECT_RECEIVED,
    payload: {
        id: project.id,
        account_id: project.account_id,
        name: project.name,
        description: project.description,
        colour: project.colour,
        created_at: project.created_at,
        updated_at: project.updated_at,
        stories: project.stories
    }
});

const removedProject = (projectId) => ({
    type: ProjectConstants.PROJECT_REMOVED,
    payload: {
        id: projectId,
    }
});

const projectUpdated = (projectId, name, description, colour) => ({
    type: ProjectConstants.PROJECT_UPDATED,
    payload: {
        id: projectId,
        name: name,
        description: description,
        colour: colour,
    }
});

export function listProjects(storyId) {
    return function (dispatch) {
        return ProjectApi.listProjects(storyId).then(response => {
            _.map(response, project => {
                dispatch(receivedProject(project));
            });

            return response;
        });
    };
}

export function getProject(projectId) {
    return function (dispatch) {
        return ProjectApi.getProject(projectId).then(project => {
            dispatch(receivedProject(project));

            return project;
        });
    };
}

export function createProject(storyId, name, description) {
    return function (dispatch) {
        return ProjectApi.createProject(storyId, name, description).then(response => {
            return dispatch(getProject(response.id));
        });
    };
}


export function updateProject(projectId, name, description, colour) {
    return function (dispatch) {
        return ProjectApi.updateProject(projectId, name, description, colour).then(() => {
            dispatch(projectUpdated(projectId, name, description, colour));
        });
    }
}

export function removeProject(projectId) {
    return function (dispatch) {
        dispatch(removedProject(projectId));

        return ProjectApi.removeProject(projectId);
    }
}
